module.exports = __webpack_public_path__ + "static/img/far3_active.727bba05.png";